//@flow
import {DatePicker} from 'antd';
import moment from 'moment';
import React, {useCallback} from 'react';

import {FilterItem, OrgUnitSelect} from '../../../components';
import Field from '../../../components/card/Field';
import {CommonFilter, type FilterProps} from '../../../components/hoc/common/handbook/CommonFilter';

import Selects from '../../../components/selects';
import {formatDateTimeToISOString} from '../../../lib/helpers';
import type {CognosLogStatusType} from '../../../lib/types';

const { BudgetVersionSelect, YearSelect, CognosLogStatusSelect } = Selects;

export type PlaceParamsFilter = {
  nodeId?: number,
  'branchBudgetSummary.budgetSummary.budgetVersion.id'?: number,
  year?: number,
  status?: CognosLogStatusType,
  startDate?: string,
  endDate?: string
};

export const PlaceFilter = (props: FilterProps<PlaceParamsFilter>) => {
  const Filter = useCallback(
    (filterProps: $Shape<FilterProps<PlaceParamsFilter>>) =>
      CommonFilter<PlaceParamsFilter>({ ...filterProps, ...props }),
    [props]
  );
  return (
    <Filter additionalFilter>
      {(values, changeValue) => (
        <>
          <FilterItem>
            <Field mBottomNone>
              <OrgUnitSelect
                size="small"
                value={values.nodeId}
                onlyBranches
                onChange={value => changeValue('nodeId', value)}
                isFilter={true}
              />
            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <BudgetVersionSelect
                size="small"
                value={
                  values['branchBudgetSummary.budgetSummary.budgetVersion.id']
                }
                onChange={value =>
                  changeValue(
                    'branchBudgetSummary.budgetSummary.budgetVersion.id',
                    value
                  )
                }
              />
            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <YearSelect
                size="small"
                value={values.year}
                onChange={value => changeValue('year', value)}
              />
            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <CognosLogStatusSelect
                size="small"
                value={values.status}
                onChange={value => changeValue('status', value)}
              />
            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <DatePicker
                size="small"
                placeholder="Дата начала отправки данных"
                value={values.startDate ? moment(values.startDate) : undefined}
                format={'DD.MM.YYYY'}
                onChange={(value, dateString) => {
                  changeValue(
                    'startDate',
                    formatDateTimeToISOString(value, dateString) || undefined
                  );
                }}
              />
            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <DatePicker
                size="small"
                placeholder="Дата окончания отправки данных"
                value={values.endDate ? moment(values.endDate) : undefined}
                format={'DD.MM.YYYY'}
                onChange={(value, dateString) => {
                  changeValue(
                    'endDate',
                    formatDateTimeToISOString(value, dateString) || undefined
                  );
                }}
              />
            </Field>
          </FilterItem>
        </>
      )}
    </Filter>
  );
};
export default PlaceFilter;
